import { Timestamp, Tooltip } from '@dixa/lib-shared-habla';
import * as React from 'react';

import { Score, ScoreIcon, ScoreIconStyle } from 'fable/ScoreIcon';

import sharedStyles from '../../message/message.module.scss';

import styles from './satisfactionMessage.module.scss';

interface PropsT {
  comment: string;
  score: Score;
  ratingStyle: ScoreIconStyle;
  date: string;
  /** Is this the newest message? */
  newest?: boolean;
}

export const SatisfactionMessage: React.FunctionComponent<PropsT> = ({
  ratingStyle,
  score,
  comment,
  date,
  newest,
}) => (
  <div className={styles.root}>
    <div className={styles.score}>
      <Tooltip content={`${score} out of 5`} wrap="span" dark>
        <ScoreIcon style={ratingStyle} score={score} />
      </Tooltip>
    </div>
    <div className={styles.content}>
      <div className={styles.description}>Satisfaction rating received</div>
      <div className={styles.comment}>{comment || 'No comment'}</div>
    </div>
    <div className={styles.date}>
      {!!date && (
        <Timestamp
          time={date}
          relative={newest}
          className={sharedStyles.timestamp}
        />
      )}
    </div>
  </div>
);
